export default () => Math.random().toString().slice(2);
//# sourceMappingURL=randomId.mjs.map